import Vue from 'vue'
import VueRouter from 'vue-router'
import Countries from '@/views/Countries.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Countries',
    component: Countries
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
